import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7fdd8c79&scoped=true"
import script from "./serve.js?vue&type=script&lang=js&external"
export * from "./serve.js?vue&type=script&lang=js&external"
import style0 from "./serve.scss?vue&type=style&index=0&id=7fdd8c79&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=7fdd8c79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdd8c79",
  null
  
)

export default component.exports